import gsap from "gsap";
import { CARD_COUNT } from "../utils/config";

export function loadIntro({ field, onComplete }) {
  const cards = field.cards;
  const words = [...document.querySelectorAll(".copy__word")];
  const copy = document.getElementById("copy");
  const hint = document.querySelector(".copy__hint");

  const tl = gsap.timeline({
    defaults: { ease: "power2.inOut" },
  });

  cards.forEach((card, i) => {
    tl.to(
      card.anim,
      {
        opacity: 1,
        duration: 0.35,
        ease: "power1.out",
      },
      i * 0.025,
    );
  });

  tl.addLabel("line", "+=0.1");
  cards.forEach((card, i) => {
    const row = field.rowPos(i);
    tl.to(
      card.anim,
      {
        x: row.x,
        y: row.y,
        z: 0,
        rotX: 0,
        rotY: 0,
        rotZ: 0,
        duration: 1.35,
        ease: "power3.inOut",
      },
      "line",
    );
  });

  tl.addLabel("ring", "line+=1.45");
  cards.forEach((card, i) => {
    const ring = field.ringPos(i);
    const fromCenter = Math.min(i, CARD_COUNT - 1 - i);
    tl.to(
      card.anim,
      {
        x: ring.x,
        y: ring.y,
        z: 0,
        rotX: 0,
        rotY: 0,
        rotZ: ring.rotZ,
        duration: 1.65,
        ease: "power3.inOut",
      },
      `ring+=${fromCenter * 0.028}`,
    );
  });

  gsap.set(copy, { autoAlpha: 0 });
  gsap.set(words, { yPercent: 110, opacity: 0 });
  gsap.set(hint, { autoAlpha: 0, y: 10 });

  tl.set(copy, { autoAlpha: 1 }, "ring+=0.45");
  tl.to(
    words,
    {
      yPercent: 0,
      opacity: 1,
      duration: 0.95,
      stagger: 0.012,
      ease: "power2.inOut",
    },
    "ring+=0.45",
  );
  tl.to(
    hint,
    {
      autoAlpha: 1,
      y: 0,
      duration: 1.15,
      ease: "expo.out",
    },
    "ring+=1.1",
  );

  tl.add(() => onComplete?.(), "ring+=1.7");
  return tl;
}
